import moment from 'moment';

import {
  FRONT_CONVERSATION_STATUS_ASSIGNED,
  FRONT_CONVERSATION_STATUS_UNASSIGNED,
} from 'common/frontConstants';

const statusList = [
  FRONT_CONVERSATION_STATUS_ASSIGNED,
  FRONT_CONVERSATION_STATUS_UNASSIGNED,
];

export default function isFrontConversationNotAnswered(userFrontConversation) {
  return (
    statusList.includes(userFrontConversation.conversationStatus)
    && !!userFrontConversation.lastMessageSentDate
    && moment(userFrontConversation.lastMessageSentDate)
      .isAfter(userFrontConversation.lastMessageReceivedDate)
  );
}
